import styles from './CustomModalOverlay.module.css';

interface CustomModalOverlayProps {
  open: any;
  onClose?: any;
  title?: any;
  subTitle?: any;
  width?: string;
  height?: string;
  children?: any;
  withCloseButton?: any;
  className?: string;
  maxBodyHeight?: string;
  footer?: React.ReactNode;
  fullScreen?: boolean;
}

export default function CustomModalOverlay({
  open,
  onClose,
  title,
  subTitle,
  width = '500px',
  height = 'fit-content',
  children,
  withCloseButton,
  className = '',
  maxBodyHeight,
  footer,
  fullScreen = false,
}: CustomModalOverlayProps) {
  if (!open) return null;

  return (
    <div className="modal fixed inset-0 flex items-center justify-center z-50">
      {/* Overlay */}
      <div
        onClick={onClose}
        className={`modal-overlay absolute bg-black-1/40 opacity-100 ${
          fullScreen ? 'inset-0' : 'inset-10'
        }`}
      ></div>

      {/* Modal Content */}
      <div
        className={`bg-frame-inner shadow-lg relative flex flex-col p-0 ${
          fullScreen ? 'rounded-none' : 'rounded-xl max-h-[90vh]'
        } ${styles.fixedScrollbar} ${className}`}
        style={{
          width: fullScreen ? '100vw' : width,
          height: fullScreen ? '100vh' : footer ? 'auto' : height,
          maxHeight: fullScreen ? '100vh' : '90vh',
        }}
      >
        {/* Header */}
        <div
          className={`${
            fullScreen
              ? 'px-6 py-6 lg:px-10 lg:py-8'
              : footer
                ? 'px-8 py-8 pb-0'
                : 'px-8 pt-8'
          } flex-shrink-0`}
        >
          {title && (
            <div className="pb-2">
              {title && (
                <h1 className="text-xl font-bold text-text-primary-heading ">
                  {title}
                </h1>
              )}

              {subTitle && (
                <p className="text-sm 3xl:text-base text-text-primary-body mb-2 mt-1 whitespace-pre-wrap">
                  {subTitle}
                </p>
              )}
            </div>
          )}
        </div>

        {/* Modal Body */}
        <div
          className={`text-text-primary-body flex-1 min-h-0 ${
            footer ? 'px-8 overflow-y-auto' : ''
          } ${styles.fixedScrollbar}`}
          style={
            maxBodyHeight && !footer
              ? { maxHeight: maxBodyHeight, overflowY: 'auto' }
              : undefined
          }
        >
          {footer ? (
            children
          ) : (
            <div
              className={`h-full ${
                fullScreen ? 'px-6 pb-6 lg:px-10 lg:pb-10' : 'px-8 pb-8'
              }`}
            >
              {children}
            </div>
          )}
        </div>

        {/* Footer */}
        {footer && (
          <div className={`flex-shrink-0 px-8 py-8 pt-8`}>{footer}</div>
        )}

        {withCloseButton && (
          <div
            onClick={onClose}
            className="hover:opacity-80 transition-all duration-200 cursor-pointer flex justify-center items-center absolute top-5 right-[30px] w-[25px] h-[25px]"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.16992 14.8299L14.8299 9.16992"
                stroke="#E58484"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.8299 14.8299L9.16992 9.16992"
                stroke="#E58484"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="#E58484"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
}
